import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import DashboardHalfDonutChart from '@components/pages/Dashboard/MetricCharts/DashboardHalfDonutChart.component'
import DashboardSectionEmptyState from '@components/pages/Dashboard/DashboardSectionEmptyState.component'
import type { UseCollectionResult } from '@hooks/dashboard/useCollection'
import {
  formatChartCurrencyKUnits,
  HYGIENE_PLACEHOLDER,
} from '@utils/dashboardFinance.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import {
  FinanceHalfDonutLegend,
  FinanceHalfDonutMetricsTiles,
} from '../../FinanceMetricTiles.component'

type InsurancePatientCollectionCardProps = {
  titleHref: string
  collection: UseCollectionResult
}

export function InsurancePatientCollectionCard({
  titleHref,
  collection,
}: InsurancePatientCollectionCardProps): React.ReactElement {
  const {
    loading,
    insuranceStr,
    patientStr,
    donut,
    hasPayload,
    hasPayerSplitData,
  } = collection
  const isEmpty = shouldShowDashboardSectionEmpty(loading, hasPayerSplitData)
  const pending = isDashboardSectionPending(loading, hasPayload)

  return (
    <DashboardSectionCard
      title="Insurance vs patient collection"
      titleHref={titleHref}
      className="dashboard-finance-half-donut-card"
      loading={pending}
      skeleton={{ metrics: 2, block: 'chart' }}
      isEmpty={isEmpty}
      disableTitleLink={isEmpty}
    >
      <div className="dashboard-finance-half-donut-content">
        <FinanceHalfDonutMetricsTiles
          metrics={[
            {
              id: 'insurance-collection',
              leftLabel: 'Insurance collection',
              value: loading ? HYGIENE_PLACEHOLDER : insuranceStr,
            },
            {
              id: 'patient-collection',
              leftLabel: 'Patient collection',
              value: loading ? HYGIENE_PLACEHOLDER : patientStr,
            },
          ]}
        />
        {isEmpty ? (
          <DashboardSectionEmptyState className="dashboard-section-empty--embed" />
        ) : (
          <>
            <div className="dashboard-finance-half-donut-chart-area">
              <DashboardHalfDonutChart
                title=""
                primaryValue={loading ? 0 : donut.primaryK}
                secondaryValue={loading ? 0 : donut.secondaryK}
                valueFormatter={formatChartCurrencyKUnits}
                slices={loading ? [] : donut.slices}
                hideCenterMetric
                className="dashboard-finance-half-donut"
              />
            </div>
            <FinanceHalfDonutLegend slices={donut.slices} />
          </>
        )}
      </div>
    </DashboardSectionCard>
  )
}
